import { render, staticRenderFns } from "./AccountSettingsNav.vue?vue&type=template&id=9ca97f0c"
import script from "./AccountSettingsNav.vue?vue&type=script&lang=js"
export * from "./AccountSettingsNav.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsNav.vue?vue&type=style&index=0&id=9ca97f0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports